import React, { useState, useEffect } from "react";
import Gallery from "react-stack-gallery";
// import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import axios from "axios";
import Masonry from 'react-masonry-css'
var { Modal } = require("react-bootstrap");
import ImagePage from "./ImagePage";
import { EmailShareButton, WhatsappShareButton } from "react-share";
import querystring from "querystring";
import MobileNav from "../RealEventsListing/MobileNav";
import { callGa } from "../general/generalUtil";
const SearchImages = ({
  searchImagesTags,
  tagsData,
  pageType,
  loginPopup,
  sessionData,
  searchQueryText,
  loadingTags,
  searchImageText,
  handleScrollTop,
}) => {
  const [imagesData, setImagesData] = useState([]);
  const [imagesCounts, setImagesCounts] = useState([]);
  const [attachTypes, setAttachTypes] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [tId, setTId] = useState("");
  const [tagsSection, setTagsSection] = useState(false);
  const [tagName, setTagName] = useState(searchQueryText);
  const [newTagName, setNewTagName] = useState("");
  const [saveModal, setSaveModal] = useState();
  const [albumModal, setAlbumModal] = useState(false);
  const [albumName, setAlbumName] = useState("");
  const [shareSection, setShareSection] = useState();
  const [albumModalMobile, setAlbumModalMobile] = useState(false);
  const [loadingNew, setLoadingNew] = useState(false);
  const [imageId, setImageId] = useState("");
  const [vendorName, setVendorName] = useState();
  const [loadingSingleImage, setLoadingSingleImage] = useState(false);
  const [attachementId, setAttachmentId] = useState("");
  const [albumData, setAlbumData] = useState([]);
  const [image, setImage] = useState(null);
  const [tagTitle, setTagTitle] = useState(null);
  const [pinkImage, setPinkImage] = useState("");
  const [offSet, setOffSet] = useState(0);
  const [imageIds, setImageIds] = useState([]);
  const [newImageInput, setNewImageInput] = useState("");
  const [singleImageModal, setSingleImageModal] = useState(false);
  const getImages = (id, name) => {
    setNewTagName(name);
    setTagName(name);
    setTId(id);
    setLoadingData(true);
    let url = `https://api.bookeventz.com/imageTags/getImagesByTags?tag_id=${id}&searchText=${tagName}&if_active=1&start=0&limit=30`;
    try {
      axios.get(url).then((res) => {
        setImagesData(res.data.data);
        setImagesCounts(res.data.total_count);
        setAttachTypes(res.data.attachType);
        setLoadingData(false);
      });
    } catch (err) {
      console.log(err, "error");
    }
  };

  const getMoreImages = (id, name, input) => {
    let dNum = imagesData.length + input;
    let url = `https://api.bookeventz.com/imageTags/getImagesByTags?tag_id=${tId}&searchText=${name}&if_active=1&start=${dNum}&limit=20`;
    try {
      axios.get(url).then((res) => {
        let newData = res.data.data;
        let nData = imagesData.concat(newData);
        setImagesData(nData);
      });
    } catch (err) {
      console.log(err, "error");
    }
  };
  const handleSaveModal = (index) => {
    if (index == saveModal) {
      setSaveModal(null);
    } else {
      setSaveModal(index);
    }
  };
  const createAlbum = () => {
    if ("userName" in sessionData) {
      setLoadingNew(true);
      let url = `https://api.bookeventz.com/ImageTags/createImageTagAlbum`;
      let formData = {
        name: albumName,
        user_profile_id: sessionData?.user_profile_id,
        is_active: 1,
      };
      axios.post(url, querystring.stringify(formData)).then((formUpdate) => {
        if (formUpdate.data?.success == true) {
          handleImageSave(formUpdate?.data?.album_id);
          getUserAlbumList();
          setLoadingNew(false);
          setAlbumModal(!albumModal);
          handleBothModals();
        }
      });
      (error) => {
        console.log(error);
      };
    } else {
      loginPopup(true);
    }
  };
  const handleAlbum = () => {
    setAlbumModalMobile(false);
    setAlbumModal(!albumModal);
  };
  const handleShareModal = (index) => {
    if (index == shareSection) {
      setShareSection(null);
    } else {
      setShareSection(index);
    }
  };
  const handleMobileAlbum = () => {
    setAlbumModalMobile(!albumModalMobile);
  };

  const handleBothModals = (index, iid) => {
    if ("userName" in sessionData) {
      setAttachmentId(iid);
      setImageId(index);
      if (window.innerWidth > 768) {
        handleSaveModal(index);
      } else {
        handleMobileAlbum();
      }
    } else {
      loginPopup(true);
    }
  };
  const handleImageSave = (albumId) => {
    setLoadingSingleImage(true);
    let likeUrl = `https://api.bookeventz.com/ImageTags/insertAlbumImage`;
    let formData = {
      album_id: albumId,
      image_attachment_id: imageId,
      if_active: 1,
    };
    try {
      axios.post(likeUrl, querystring.stringify(formData)).then((formUpdate) => {
        if (formUpdate.data?.success == true) {
          setLoadingSingleImage(false);
          setAlbumModalMobile(false);
          // setPinkImage(imageId);
          handleBothModals();
        }
      });
    } catch (err) {
      console.log(err, "error");
    }
  };
  const handleVendorName = (index) => {
    // if (index == vendorName) {
    //   setVendorName(null);
    // } else {
    setVendorName(index);
    // }
  };
  const saveSingleImage = () => {
    setLoadingSingleImage(true);
    let url = `https://api.bookeventz.com/ImageTags/insertImageWihoutAlbum`;
    let formData = {
      user_profile_id: sessionData?.user_profile_id,
      image_attachment_id: attachementId,
      if_active: 1,
    };
    try {
      axios.post(url, querystring.stringify(formData)).then((formUpdate) => {
        if (formUpdate.data?.success == true) {
          setImageIds((current) => [...current, attachementId]);
          setLoadingSingleImage(false);
          setAlbumModalMobile(false);
          handleBothModals();
        }
      });
    } catch (err) {
      console.log(err, "error");
    }
  };

  const getUserAlbumList = () => {
    let url = `https://api.bookeventz.com/imageTags/getUsersAlbum?user_profile_id=${sessionData?.user_profile_id}&is_active=1`;
    try {
      axios.get(url).then((res) => {
        setAlbumData(res.data.data);
      });
    } catch (err) {
      console.log(err, "error");
    }
  };

  const download = async (url, name) => {
    let link = "https://media.bookeventz.com/html/bookeventz.com/images/restaurant-picture/" + url;
    const a = document.createElement("a");
    a.href = await toDataURL(link);
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  };

  const toDataURL = (url) => {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      getUserAlbumList();
    }, 2000);
  }, [sessionData]);
  useEffect(() => {
    if (searchQueryText != "") {
      getImages("", searchQueryText);
    }
  }, [searchQueryText]);
  const setParams = (url, tag_id) => {
    history.pushState(
      {},
      "",
      "search?searchText=" + url + "&tag_id=" + tag_id + "&tag_title=" + tagTitle
    );
  };
  useEffect(() => {
    const onScroll = () => setOffSet(window.pageYOffset);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    handleScrollTop = () => {
      let element = $("#search-a");
      let offsetAboutTop = element.offset();
      let aboutScreen = offsetAboutTop.top - 0;
      window.scrollTo({
        top: aboutScreen,
        behavior: "auto",
      });
    };
  }, [imagesData]);
  const handleSingleImageModaL = (name) => {
    setNewImageInput(name);
    setSingleImageModal(true);
  };
  return (
    <>
      {offSet > 100 && (
        <MobileNav
          searchImagesTags={searchImagesTags}
          loadingTags={loadingTags}
          tagsData={tagsData}
          handleScrollTop={handleScrollTop}
          oName={newTagName}
        />
      )}
      <div
        id="search-a"
        className="extrasearch-a"
        onClick={() => {
          if (shareSection !== null) {
            setShareSection(null);
          }
        }}
      >
        <div
          id="s-a-4"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              setTagsSection(!tagsSection);
              getImages("", tagName);
            }
          }}
        >
          <img src="../../media/blackSearch.svg" alt="Black Search Icon" />
          <input
            type="text"
            value={tagName}
            defaultValue={searchQueryText}
            placeholder="Search"
            onChange={(e) => {
              searchImagesTags(e.target.value);
              setTagName(e.target.value);
              setParams(e.target.value, "");
            }}
            onFocus={() => {
              setTagsSection(true);
            }}
            onBlur={() => {
              setTimeout(() => {
                setTagsSection(false);
              }, 200);
            }}
          />
        </div>
        {tagsData.length > 0 && tagsSection && (
          <div id="tags-wrapper" className="tags-wrapper">
            <ul id="tags">
              {tagsData.length > 0 &&
                tagsData?.map((t, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      getImages(t.id, t.name);
                      setTagName(t.name);
                      setParams(t.name, t.id);
                      setTagsSection(!tagsSection);
                    }}
                  >
                    {t.name}
                  </li>
                ))}
            </ul>
          </div>
        )}
      </div>
      {imagesData?.length > 0 && (
        <div id="coutn-images">
          {newTagName} ({imagesCounts} Images)
        </div>
      )}
      <div
        id="cards-container"
        className="card-container"
        onClick={() => {
          if (shareSection !== null) {
            setShareSection(null);
          }
        }}
      >
        {loadingData ? (
          <div id="loading">
            <img src="../../media/Pino.svg" alt="Loading..." />
          </div>
        ) : imagesData?.length > 0 ? (
          <Masonry
            breakpointCols={3}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {imagesData?.map((el, i) => {
              let aTypeUrl = "";
              const type = parseInt(el.attach_type);
              switch (type) {
                case 3:
                  aTypeUrl = `https://media.bookeventz.com/884x350/html/bookeventz.com/images/banquet-layout/${el.image_name}`;
                  break;
                case 1:
                  aTypeUrl = `https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-picture/${el.image_name}`;
                  break;
                case 2:
                  aTypeUrl = `https://media.bookeventz.com/884x350/html/bookeventz.com/images/restaurant-award/${el.image_name}`;
                  break;
                case 12:
                  aTypeUrl = `https://media.bookeventz.com/884x350/html/bookeventz.com/images/albums/${el.image_name}`;
                  break;
              }
              const aTypes = attachTypes.find((o) => o.id === type);
              if (aTypes) {
                aTypeUrl = `${aTypes.unique_link}${el.image_name}`;
              }
              return (
                <>
                  <div
                    key={i}
                    id="img-wrapper-8"
                    onMouseEnter={() => handleVendorName(el.id)}
                    onMouseLeave={() => handleVendorName(el.id)}
                  >
                    {el.id === saveModal && (
                      <div id="create-al-new-modal">
                        {loadingSingleImage ? (
                          <div id="loading9">
                            <img src="../../media/Pino.svg" alt="Loading..." />
                          </div>
                        ) : (
                          <>
                            <span id="sll">
                              <span onClick={() => saveSingleImage(el.attachement_id)}>Save Image</span>
                              <span id="close-this-shit" onClick={handleBothModals}>
                                <img src="../../media/closo.svg" alt="Close Icon" />
                              </span>
                            </span>

                            {albumData.length > 0 && (
                              <>
                                <span id="sl">Save to Album</span>
                                {albumData.map((a, index) => (
                                  <span key={index} id="wl" onClick={() => handleImageSave(a.id)}>
                                    {a.name}
                                  </span>
                                ))}
                              </>
                            )}
                            <div id="ddr"></div>
                            <span id="sl">Save Image in a New Album</span>
                            <div id="cAl" onClick={handleAlbum}>
                              <span>
                                <img src="../../media/pinkyH.svg" alt="Pink Plus Icon" />
                              </span>
                              Create Album
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {window.innerWidth > 768 ? (
                      el.id === vendorName && (
                        <a href={`https://www.bookeventz.com/${el.product_link}`} target="_blank" rel="noopener noreferrer">
                          <div id="shareN">
                            <img src="../../media/shareN.svg" alt="Share Icon" />
                            {el.product_name.length > 22 ? `${el.product_name.slice(0, 22)}...` : el.product_name}
                          </div>
                        </a>
                      )
                    ) : (
                      <a href={`https://www.bookeventz.com/${el.product_link}`} target="_blank" rel="noopener noreferrer">
                        <div id="shareN">
                          <img src="../../media/shareN.svg" alt="Share Icon" />
                          {el.product_name.length > 12 ? `${el.product_name.slice(0, 12)}...` : el.product_name}
                        </div>
                      </a>
                    )}

                    <img
                      src={aTypeUrl}
                      alt="Event"
                      onClick={() => {
                        handleVendorName(el.id);
                        handleSingleImageModaL(el.image_name);
                      }}
                      style={{
                        width: "100%",
                        display: "block",
                        objectFit: "cover",
                        height: "100%",
                      }}
                    />

                    <a href="#" onClick={() => download(el.image_name, el.image_name)}>
                      <img src="../../media/dLoad.svg" alt="Download Icon" id="LoadD" />
                    </a>

                    <img
                      src={imageIds?.includes(el.image_attachement_id) ? "../../../media/pHeart.svg" : "../../../media/wHeart.svg"}
                      alt="Heart Icon"
                      id="HeartP"
                      onClick={() => handleBothModals(el.id, el.image_attachement_id)}
                    />

                    <img
                      src="../../../media/sh.svg"
                      alt="Share Icon"
                      id="Hs"
                      onClick={() => handleShareModal(el.id)}
                    />

                    {el.id === shareSection && (
                      <div id="share-wrapper">
                        <a
                          href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/image-page?imageText=${el.image_name}`}
                          data-action="share/whatsapp/share"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src="../../../media/watti.svg" alt="WhatsApp Share" />
                        </a>
                        <EmailShareButton
                          url={`https://grunt.bookeventz.com/real-events/image-page?imageText=${el.image_name}`}
                          subject={el.description || el.product_name}
                        >
                          <img src="../../../media/gmail.svg" alt="Gmail Share" />
                        </EmailShareButton>
                      </div>
                    )}
                  </div>
                  {el.description && (
                    <p className="wed-desc">
                      {el.description.replace(/,/g, ', ')}
                    </p>
                  )}
                </>
              );
            })}
          </Masonry>
        ) : (
          <div id="sorry">
            <img src="../../../media/Frame.svg" alt="No Images Found" />
            <span id="no-img2">Search for an Image Idea</span>
          </div>
        )}

        {imagesData?.length > 0 && (
          <div id="lo-0">
            <button onClick={() => getMoreImages("", tagName, 20)}>Load more</button>
          </div>
        )}
      </div>
      <Modal dialogClassName={"album-create-modal"} show={albumModal} onHide={handleAlbum}>
        <div id="create-Album">
          {loadingNew == true ? (
            <>
              <div id="loading">
                <img src="../../media/Pino.svg" alt="Loading image" />
              </div>
            </>
          ) : (
            <>
              {" "}
              <input
                type="text"
                placeholder="Create Album"
                onChange={(e) => setAlbumName(e.target.value)}
              />
              <div id="bt87">
                <button onClick={() => handleAlbum()}>Cancel</button>
                <button onClick={() => createAlbum()}>Create</button>
              </div>
            </>
          )}
        </div>
      </Modal>
      <Modal
        dialogClassName={"mobile-album-create-modal"}
        show={albumModalMobile}
        onHide={handleMobileAlbum}
      >
        <div id="create-al-new-modal-mobile">
          <span id="close-this-shit" onClick={() => handleMobileAlbum()}>
            <img src="../../media/closo.svg" alt="Close Iocn" />
          </span>
          <span id="sll" onClick={() => saveSingleImage()}>
            Save Image
          </span>
          {albumData.length > 0 && albumData !== undefined && (
            <>
              <span id="sl">Save to Album</span>
              {albumData !== undefined &&
                albumData?.map((a, i) => {
                  return (
                    <span id="wl" onClick={() => handleImageSave(a.id)}>
                      {a.name}
                    </span>
                  );
                })}
            </>
          )}
          <div id="ddr"></div>
          <span id="sl">Save Image in a New Album</span>
          <div id="cAl">
            <span onClick={() => handleAlbum()}>
              <img src="../../media/pinkyH.svg" alt="Pink Plus Icon" />
            </span>
            Create Album
          </div>
        </div>
      </Modal>
      <Modal
        dialogClassName={"gallery-modal"}
        show={singleImageModal}
        onHide={setSingleImageModal}
        animation={false}
      >
        <ImagePage
          searchImageText={searchImageText}
          newImageInput={newImageInput}
          Modal={setSingleImageModal}
          sessionData={sessionData}
        />
      </Modal>
    </>
  );
};

export default SearchImages;
